import { useUser } from '@clerk/clerk-react'
import { noop } from '@saaga/shared/utils/noop.util'
import type { ReactNode } from 'react'

import { ChatInputComposer } from '@/components/chat/chat-input-composer.organism'
import { ChatVirtualList } from '@/components/chat/chat-virtual-list.organism'

import type { useDraftAgencyPreviewChat } from '@/hooks/use-draft-agency-preview-chat.hook'

interface AgencyPreviewChatContentProps {
  state: ReturnType<typeof useDraftAgencyPreviewChat>['state']
  handlers: ReturnType<typeof useDraftAgencyPreviewChat>['handlers']
  conversationId: string | null
}

export const AgencyPreviewChatContent = ({
  state,
  handlers,
  conversationId,
}: AgencyPreviewChatContentProps): ReactNode => {
  const { user } = useUser()

  return (
    <div className="agency-preview-chat-content flex h-full flex-col">
      <div className="agency-preview-chat-messages flex-1 overflow-hidden">
        <ChatVirtualList
          itemList={state.itemList}
          currentUserId={user?.id ?? ''}
          conversationId={conversationId ?? undefined}
          isFollowOutputEnabled={true}
          isAnimationEnabled={true}
          onToolCallClick={noop}
          onMessageClick={noop}
          onContentBriefClick={noop}
          className="scrollbar-thin"
        />
      </div>
      <div className="agency-preview-chat-input border-t bg-background p-3">
        <ChatInputComposer
          value={state.inputValue}
          onChange={handlers.setInputValue}
          mode={state.inputMode}
          onModeChange={handlers.setInputMode}
          onSend={handlers.handleSend}
          isLoading={state.isLoading}
          placeholder="Test your agency..."
        />
      </div>
    </div>
  )
}

AgencyPreviewChatContent.displayName = 'AgencyPreviewChatContent'
